import React from 'react';

import { connectI18n } from '../../connects';
import Blocklink from '../../elements/Blocklink';
import HomeLogo from '../../elements/HomeLogo';
import Screen from '../Screen';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';


class MissingCode extends React.Component {
    render() {
        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBar returnURL="/add" />
                    <HomeLogo />
                    <br />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <h1>{i18n['label.eventcode']}</h1>
                    <div className="content">
                        <p>{i18n['label.eventcode.explain.line1']}</p>
                        <p>{i18n['label.eventcode.explain.line2']}</p>
                    </div>
                    <Blocklink right next href="/">
                        {i18n['label.go.MyNetworkapp']}
                    </Blocklink>
                </Scrollable>
            </Screen>
        );
    }
}

export default connectI18n(MissingCode);
